import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';

export default class extends Controller {
  static targets = ['elementToHide'];
  static values = { name: String };

  connect() {
    if (this.tooltipDismissed()) {
      return;
    }

    this.elementToHideTarget.classList.remove('hidden');
  }

  dismiss() {
    this.elementToHideTarget.classList.add('hidden');
    Cookies.set(this.cookieName(), true, {
      expires: 365,
      path: window.location.pathname
    });
  }

  cookieName() {
    return `${this.nameValue}_dismissed`;
  }

  tooltipDismissed() {
    return Cookies.get(this.cookieName()) === 'true';
  }
}
